"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controller = void 0;
const strip_ansi_1 = __importDefault(require("strip-ansi"));
/**
 * Overlay controller
 * @public
 */
class Controller {
    /**
     * Class constructor
     * @public
     */
    constructor() {
        this.element = document.createElement('bud-error');
        document.body && document.body.appendChild(this.element);
    }
    /**
     * Formatted error message
     * @public
     */
    get message() {
        return this.payload.errors?.reduce((a, c) => `${a}
        <div>
          <span>${c?.title ?? 'Compilation error'}</span>
          <pre>${(0, strip_ansi_1.default)(c?.message) ?? ''}</pre>
        </div>`, ``);
    }
    /**
     * Update element
     * @public
     */
    update(payload) {
        this.payload = payload;
        this.element.setAttribute('message', this.message ?? ``);
    }
}
exports.Controller = Controller;
